import dayjs from "dayjs";
import {
  Button,
  Group,
  Select,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  FOLLOWUP_PRIORITY_OPTIONS,
  FOLLOWUP_TYPE_OPTIONS,
} from "../utils/leadsOptions";
import { LeadFollowupTimeline } from "./LeadTimeline";

const LeadFollowups = ({
  followups,
  isLoading,
  followupForm,
  onFollowupFormChange,
  onSubmit,
  isSubmitting,
}) => (
  <Stack gap="lg">
    <LeadFollowupTimeline items={followups} isLoading={isLoading} />
    <Stack gap="sm">
      <Text fw={600}>Schedule Follow-up</Text>
      <form onSubmit={onSubmit}>
        <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
          <TextInput
            label="Person Name"
            withAsterisk
            value={followupForm.person_name}
            onChange={(e) => onFollowupFormChange({ person_name: e.target.value })}
            required
          />
          <TextInput
            label="Phone"
            value={followupForm.phone}
            onChange={(e) => onFollowupFormChange({ phone: e.target.value })}
          />
          <DatePickerInput
            label="Due Date"
            placeholder="mm/dd/yyyy"
            withAsterisk
            value={followupForm.due_date}
            onChange={(value) => onFollowupFormChange({ due_date: value })}
            minDate={dayjs().startOf("day").toDate()}
            required
          />
          <Select
            label="Type"
            data={FOLLOWUP_TYPE_OPTIONS}
            value={followupForm.followup_type}
            onChange={(value) =>
              onFollowupFormChange({ followup_type: value || "OUTBOUND_CALL" })
            }
          />
          <Select
            label="Priority"
            data={FOLLOWUP_PRIORITY_OPTIONS}
            value={followupForm.priority}
            onChange={(value) => onFollowupFormChange({ priority: value || "MEDIUM" })}
          />
          <TextInput
            label="Activity"
            value={followupForm.trek}
            onChange={(e) => onFollowupFormChange({ trek: e.target.value })}
          />
        </SimpleGrid>
        <Textarea
          label="Notes"
          placeholder="Notes"
          value={followupForm.notes}
          onChange={(e) => onFollowupFormChange({ notes: e.target.value })}
          mt="sm"
        />
        <Group justify="flex-start" mt="md">
          <Button type="submit" color="orange" loading={isSubmitting}>
            Schedule Follow-up
          </Button>
        </Group>
      </form>
    </Stack>
  </Stack>
);

export default LeadFollowups;
